import { Button, type ButtonProps, Text, type TextProps } from "@mantine/core";
import React from "react";

import styles from "./Home.module.scss";

export const HomeContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={`${styles.homeContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const HomeHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={`${styles.homeHeader} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const HomeHeaderWrapper: React.FC<
  React.ComponentPropsWithoutRef<"div">
> = ({ className, children, ...rest }) => (
  <div className={`${styles.homeHeaderWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const ButtonsContainer: React.FC<
  React.ComponentPropsWithoutRef<"div">
> = ({ className, children, ...rest }) => (
  <div className={`${styles.buttonsContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LogbooksSection: React.FC<
  { color?: string } & React.ComponentPropsWithoutRef<"div">
> = ({ color, className, style, children, ...rest }) => (
  <div
    className={`${styles.logbooksSection} ${className ?? ""}`}
    style={{
      ...style,
      ...(color
        ? {
            border: `2px solid ${color}`,
            backgroundColor: `rgba(${color.slice(4, color.length - 1)}, 0.05)`,
          }
        : {}),
    }}
    {...rest}>
    {children}
  </div>
);

export const SectionWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={`${styles.sectionWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const HomeDividerText: React.FC<TextProps> = ({
  className,
  ...props
}) => (
  <Text className={`${styles.homeDividerText} ${className ?? ""}`} {...props} />
);

export const HomeLogbooks: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={`${styles.homeLogbooks} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Separator: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div className={`${styles.separator} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const NoEntries: React.FC<
  React.HTMLAttributes<HTMLParagraphElement>
> = ({ className, children, ...rest }) => (
  <p className={`${styles.noEntries} ${className ?? ""}`} {...rest}>
    {children}
  </p>
);

export const OpenButton: React.FC<ButtonProps> = ({ className, ...props }) => (
  <Button className={`${styles.openButton} ${className ?? ""}`} {...props} />
);

export const _LogName: React.FC<TextProps> = ({ className, ...props }) => (
  <Text className={`${styles.logName} ${className ?? ""}`} {...props} />
);

export const LogName: React.FC<TextProps> = props => <_LogName {...props} />;

export const HomeLogbookOpenBtn: React.FC<
  React.ComponentPropsWithoutRef<"div">
> = ({ className, children, ...rest }) => (
  <div className={`${styles.homeLogbookOpenBtn} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const StyledStatusButton: React.FC<
  { active?: boolean } & React.ComponentPropsWithoutRef<"button">
> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- omitted from the rest props on purpose
  active: _active,
  className,
  children,
  ...rest
}) => (
  <button
    type="button"
    className={`${styles.styledStatusButton} ${className ?? ""}`}
    {...rest}>
    {children}
  </button>
);

export const LeftSideWrapper: React.FC<
  React.ComponentPropsWithoutRef<"div">
> = ({ className, children, ...rest }) => (
  <div className={`${styles.leftSideWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
